import React, { useState } from "react";
import { FaCheck, FaEdit, FaTimes } from "react-icons/fa";
import { FlexBox, Option } from "../../primitives";
import { StatusBadge } from "../SectionUploadCards/TransactionCreateCards.styled";
import { StyledSelect } from "../../common/common.style";

type StatusType =
  | "PENDING"
  | "SUCCESS"
  | "FAILED"
  | "NOT_SUPPORTED"
  | "PARTIALLY_SUCCESSFUL";

interface StatusEditableProps {
  statuses: StatusType[];
  status: StatusType;
  isEditStatus: boolean;
  setIsEditStatus: (arg1: boolean) => void;
  onConfirmNewStatus: (arg1: StatusType, id: number) => void;
  id: number;
}

export const StatusEditable = ({
  statuses,
  status,
  isEditStatus,
  setIsEditStatus,
  onConfirmNewStatus,
  id,
}: StatusEditableProps) => {
  const [localSelectValue, setLocalSelectValue] = useState(status);
  return (
    <FlexBox css={{ gap: 10, alignItems: "center" }}>
      {isEditStatus && (
        <StyledSelect
          value={localSelectValue}
          onChange={(e) => {
            setLocalSelectValue(e.target.value as StatusType);
          }}
          css={{ width: 100 }}
        >
          {statuses?.map((stat) => (
            <Option value={stat} key={stat}>
              {stat}
            </Option>
          ))}
        </StyledSelect>
      )}
      {!isEditStatus && <StatusBadge status={status}>{status}</StatusBadge>}
      {!isEditStatus && <FaEdit onClick={() => setIsEditStatus(true)} />}
      {isEditStatus && (
        <>
          <FaCheck
            size={20}
            color="green"
            onClick={() => onConfirmNewStatus(localSelectValue, id)}
          />
          <FaTimes
            size={20}
            color="red"
            onClick={() => setIsEditStatus(false)}
          />
        </>
      )}
    </FlexBox>
  );
};
